import { Paragraph } from "@tvg/design-system";
import React from "react";
import { ExtraInfoProps } from "./types";

const ExtraInfo = ({
  surfaceShortname,
  surfaceShortnameFontFamily,
  defaultColor,
  surfaceCondition,
  surfaceConditionFontFamily,
  distance,
  distanceFontFamily,
  raceClassShortname,
  purse
}: ExtraInfoProps) => {
  const extraInfoParagraph = [
    <Paragraph
      qaLabel={`runner-handicap-inline-pp-surface-shortname-${surfaceShortname}`}
      key="surfaceShortname"
      fontFamily={surfaceShortnameFontFamily}
      color={defaultColor}
    >
      {surfaceShortname}
    </Paragraph>,
    <Paragraph
      qaLabel={`runner-handicap-inline-pp-surface-condition-${surfaceConditionFontFamily}`}
      fontFamily={surfaceConditionFontFamily}
      key="surfaceCondition"
      color={defaultColor}
    >
      {surfaceCondition}
    </Paragraph>,
    <Paragraph
      qaLabel={`runner-handicap-inline-pp-distance-${distanceFontFamily}`}
      fontFamily={distanceFontFamily}
      key="distance"
      color={defaultColor}
    >
      {distance}
    </Paragraph>,
    <Paragraph
      qaLabel="runner-handicap-inline-pp-raceclass-shortname"
      key="raceClassShortname"
      fontFamily={surfaceShortnameFontFamily}
      color={defaultColor}
    >
      {raceClassShortname}
    </Paragraph>,
    <Paragraph
      key="purse"
      qaLabel="runner-handicap-inline-pp-purse"
      color={defaultColor}
    >
      {purse}
    </Paragraph>
  ];

  const extraInfo = extraInfoParagraph.reduce((acc, curr, index) => {
    if (index === 0) return [curr];

    return [...acc, <span key={index.toString()}> | </span>, curr];
  }, [] as JSX.Element[]);

  return <>{extraInfo}</>;
};

export default ExtraInfo;
